/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { gridSize as getGridSize } from '@atlaskit/theme/constants';
var gridSize = getGridSize();
var spinnerContainerStyles = css({
  width: "".concat(3 * gridSize, "px"),
  marginLeft: "".concat(2 * gridSize, "px")
});
/**
 * __Spinner container__
 *
 * A spinner container for loading state of Empty State.
 *
 * @internal
 */

var SpinnerContainer = function SpinnerContainer(_ref) {
  var children = _ref.children;
  return jsx("div", {
    css: spinnerContainerStyles
  }, children);
};

export default SpinnerContainer;